import React from 'react'
import { Quill } from 'react-quill'

const BlockEmbed = Quill.import('blots/block/embed')

export default class SoundcloudBlot extends BlockEmbed {
  static create (value) {
    const node = super.create()
    node.setAttribute('frameborder', 'no')
    node.setAttribute('scrolling', 'no')
    node.setAttribute('src', value.src)
    node.setAttribute('width', value.width)
    node.setAttribute('height', value.height)
    return node
  }

  static formats (node) {
    const format = {}
    if (node.hasAttribute('height')) {
      format.height = node.getAttribute('height')
    }
    if (node.hasAttribute('width')) {
      format.width = node.getAttribute('width')
    }
    if (node.hasAttribute('src')) {
      format.src = node.getAttribute('src')
    }
    return format
  }

  static value (node) {
    return node.getAttribute('src')
  }

  format (name, value) {
    if (name === 'height' || name === 'width' || name === 'src') {
      if (value) {
        this.domNode.setAttribute(name, value)
      } else {
        this.domNode.removeAttribute(name, value)
      }
    } else {
      super.format(name, value)
    }
  }
}

SoundcloudBlot.blotName = 'soundcloud'
SoundcloudBlot.tagName = 'iframe'
SoundcloudBlot.className = 'soundcloud'
Quill.register(SoundcloudBlot)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminWYSIWYGBlockEmbed.js